<template>
  <div id="contact">
    <div class="poster">
        <img src="@/common/img/jiejfa.9622adbe.png" alt="">
      </div>
    <div slot="header" style="border-bottom: 1px solid #ececec;font-weight: 700; line-height: 48px;display: flex;justify-content: center;align-items: center; font-size: 18px;">
        <span>联系我们</span>
    </div>
    <div style="display: flex; justify-content: center; padding-top: 60px;">
      <div   style=" width: 100%; max-width: 1200px; display: flex;justify-content: center;">
        <div   style="width: 40%;display: block; unicode-bidi: isolate;">
          <img  src="@/assets/images/7.jpg" alt="" style="width:100%; overflow-clip-margin: content-box; overflow: clip;">
        </div>
        <div style="flex: 1; padding-left: 80px;font-size: 16px; line-height: 32px;display: block;unicode-bidi: isolate;">
          <ul style="margin: 0;  padding: 0;display: block; list-style-type: disc;  margin-block-start: 1em;  margin-block-end: 1em; padding-inline-start: 40px; unicode-bidi: isolate;">
            <li  style="display: list-item;text-align: -webkit-match-parent; unicode-bidi: isolate; list-style: none;">
              <img  src="@/common/img/location.png" alt="" style="width:100%">
            </li>
            <li style="display: list-item;text-align: -webkit-match-parent; unicode-bidi: isolate; list-style: none;"> 鄂尔多斯市安能检测检验有限公司 </li>
            <li style="display: list-item;text-align: -webkit-match-parent; unicode-bidi: isolate; list-style: none;"> 电话：15147789878 </li>
            <li style="display: list-item;text-align: -webkit-match-parent; unicode-bidi: isolate; list-style: none;"> 邮箱：2727864284@qq.com </li>
            <li style="display: list-item;text-align: -webkit-match-parent; unicode-bidi: isolate; list-style: none;"> 公司地址：内蒙古自治区鄂尔多斯市东胜区天骄北路11号金辉大厦6号楼5层03、04 </li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listInfo } from '@/api/company'
export default {
  name: 'contact',
  data () {
    return {
      tableData: [],
      total: 0, // 分页总数
      pageNum: 1, // 分页当前页码数
      pageSize: 10, // 分页数量
      search: undefined // 搜索内容
    }
  },
  methods: {
    async loadList () {
      try {
        const res = await listInfo({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.search
        })
        if (res.code === 200) {
          this.total = res.total
          this.tableData = res.rows[0]
        }
      } catch (error) {
        this.$message.error('未知错误，请重新尝试')
      }
    },
    onSearch () {
      this.pageNum = 10
      this.pageNum = 1
      this.loadList()
    }
  },
  created () {
    // this.loadList()
  }
}
</script>

<style lang='less' scoped>
  @media screen and (max-width: 767px) {
    .map {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (min-width: 768px) {
    .map {
      width: 670px;
      height: 505px;
    }
  }
  #contact {
    .box-card {
      margin: 0 auto;
      margin-top: 20px;
      width: 90%;
      text-align: left;
    }
    .clearfix {
      span {
        font-size: 20px;
      }
    }
    ul {
      padding: 0;
    }
    li {
      font-family: Arial;
      color: #6b6b6b;
      line-height: 27px;
      margin: 0;
    }
    li:first-child {
      width: 100%;
      margin-bottom: 20px;

      img{
        width: 100%;
      }
    }
    .wx {
      width: 120px;
    }
    .wxcode {
      display: flex;
      text-align: center;
    }
  }
</style>
